module.exports = __webpack_public_path__ + "static/media/icon_back.cd8f139b.svg";